import {useState, useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import {startOfMonth, endOfMonth, getUnixTime} from 'date-fns';
import {useAuth} from '../context/AuthContext';
import { collection, onSnapshot, query, orderBy, where } from 'firebase/firestore';

const useMonthlySales = (selectedMonth, selectedYear) => {
    const [sales, setSales] = useState([]);
    const {usuario} = useAuth();
    const begin = getUnixTime(startOfMonth(new Date(selectedYear, selectedMonth)));
    const end = getUnixTime(endOfMonth(new Date(selectedYear, selectedMonth)));

    useEffect(() => {
        if(usuario){
            const queryDB = query(
                collection(db, 'sales'),
                orderBy('date', 'desc'),
                where('date', '>=', begin),
                where('date', '<=', end),
                where('userId', '==', usuario.uid)
            );

            const unsuscribe = onSnapshot(queryDB, (snapshot) => {
                setSales(snapshot.docs.map((documento) => {
                    return {...documento.data(), id: documento.id}
                }))
            }, (error) => {return error});

            return unsuscribe;
        }
    }, [usuario, begin, end]);

    return sales;
}
 
export default useMonthlySales;